import TodayBookingRequestList from "@src/components/schedule/request-list/TodayBooking";

export default function TodayBooking() {
  return <TodayBookingRequestList/>
}